import { css } from '@emotion/react'
import { colors, Tooltip } from 'plume-ui'
import { checkMemoUpdatedWithinOneWeek } from '@/lib/company'
import { CompanyMemo } from '../../../../types/api'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { Overlay } from '../../../atoms/Overlay'

type Props = {
  companyMemo: CompanyMemo | null
  setIsStatusPanelVisible: React.Dispatch<React.SetStateAction<boolean>>
}

export const MemoIcon: React.FC<Props> = ({
  companyMemo,
  setIsStatusPanelVisible,
}) => {
  return (
    <div
      css={css`
        min-width: 64px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
      `}
      data-test-id="status-panel-button"
    >
      <Tooltip
        className="status-panel-icon-tooltip"
        label={'ステータスパネルを開く'}
        place="top"
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
        >
          <Overlay
            show={checkMemoUpdatedWithinOneWeek(companyMemo)}
            overlay={
              <div
                css={css`
                  border-radius: 50%;
                  background-color: ${colors.red60};
                  width: 6px;
                  height: 6px;
                  display: flex;
                  justify-content: center;
                `}
                className="within-one-week"
              />
            }
            top={4}
            right={4}
          >
            <div
              onClick={() => setIsStatusPanelVisible(true)}
              css={css`
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                position: relative;
                border: ${companyMemo
                  ? `1px solid ${colors.blue50}`
                  : `1px dashed ${colors.white00}`};
                background-color: ${companyMemo
                  ? colors.blue50
                  : 'transparent'};
                &:hover {
                  cursor: pointer;
                  &:before {
                    background-color: rgba(0, 0, 0, 0.08);
                    position: absolute;
                    border-radius: 50%;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    content: ' ';
                  }
                }
              `}
            >
              <IcomoonIcon
                name="side-panel"
                css={css`
                  font-size: 20px;
                  z-index: 1;
                `}
              />
            </div>
          </Overlay>
        </div>

        <div
          css={css`
            margin-top: 4px;
            font-size: 11px;
            line-height: 1.25;
            text-align: center;
          `}
        >
          ステータス
          <br />
          パネル
        </div>
      </Tooltip>
    </div>
  )
}
